<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">渠道管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
<!--            <div class="content-input-item">-->
<!--              <label>启用状态</label>-->
<!--              <el-select v-model="state" placeholder="Select" class="select-item">-->
<!--                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </div>-->
            <div class="content-input-item">
              <label>渠道搜索</label>
              <el-input type="text" v-model="searchValue" placeholder="请输入渠道名称" />
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editChannelDialog(-1)" size="default">创建渠道</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="name" label="渠道" v-if="checkColList.indexOf('渠道') > -1"/>
            <el-table-column property="" label="二维码" v-if="checkColList.indexOf('二维码') > -1" >
              <template #default="scope">
                <div v-if="scope.row.smallCodeImg">
                  <el-image class="item-img" style="cursor: pointer" fit="fill" :src="scope.row.smallCodeImg" @click.prevent="showImg(scope.row.codeImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="fill"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="数据链接" v-if="checkColList.indexOf('数据链接') > -1">
              <template #default="scope">
                <p>{{scope.row.visitUrl}}<span class="copy-param" :data-clipboard-text="scope.row.visitUrl" @click="copy">复制</span></p>

              </template>
            </el-table-column>
            <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="140">
              <template #default="scope">
                <el-space direction="vertical">
                  <el-button @click="editChannelDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                  <el-button @click="downloadFile(scope.row.codeImg)" size="small" type="info">下载</el-button>
<!--                  <el-button v-if="scope.row.state == 0 || scope.row.state == 1" @click="updateState(scope.row, 2)" size="small" type="warning" v-loading="scope.row.updateLoading">下架</el-button>-->
<!--                  <el-button v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.row, 1)" size="small" type="success" v-loading="scope.row.updateLoading">上架</el-button>-->
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getChannelPageList, updateChannelState} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import ImgViewer from "@/assets/js/imageViewer";
import channelDialog from "@/views/channel/components/channelDialog";
import Clipboard from "clipboard";

export default {
  name: "ChannelIndex",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: -1},
      ],
      shopIdArr:[],
      shopId: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待展示', value: 0},
        {label: '已上架', value: 1},
        {label: '已下架', value: 2}
      ],
      state: -1,

      //刷新组
      colList: ['创建时间', '渠道', '二维码', '数据链接', '备注','操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '门店名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

    }
  },
  methods: {

    downloadFile(imgUrl) {
      window.location.href = imgUrl
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      // param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getChannelPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editChannelDialog(idx, row) {
      let _title = '';
      let channelForm = {}
      if (idx > -1) {
        _title = '编辑渠道'
        channelForm = Object.assign({}, row);
        // console.log(channelForm)
      }else {
        _title = '添加渠道'
        // console.log(channelForm)
      }
      Dialog.open({
        title: _title,
        component: channelDialog,
        data: {
          channelForm: channelForm,
          ids: idx,
          width: '600px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },



    updateState(row, state) {
      row.updateLoading = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateChannelState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateLoading = false;
      }).catch(()=> {
        row.updateLoading = false;
      })
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },

    copy() {
      let clipboard = new Clipboard('.copy-param')
      clipboard.on('success',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制成功',
          type: 'success'
        })
        clipboard.destroy() //使用destroy可以清楚缓存
      })
      clipboard.on('error',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制失败',
          type: 'success'
        })
        clipboard.destroy()
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}

.copy-param {
  color: #3a8ee6;
  cursor: pointer;
  margin-left: 8px;
}
</style>
